import React, { useState } from 'react';
import './SubscribeSection.css';

const SubscribeSection = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // 这里处理邮件订阅逻辑
    console.log('订阅邮箱:', email);
    setEmail('');
    alert('感谢您的订阅！');
  };

  return (
    <section className="subscribe-section">
      <div className="subscribe-icon">
        <span role="img" aria-label="mail">📬</span>
      </div>
      <h2>订阅获取最新更新</h2>
      <p>注册以接收有关我的新案例研究和项目的更新</p>
      
      <form onSubmit={handleSubmit} className="subscribe-form">
        <input 
          type="email" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入您的邮箱..." 
          required
        />
        <button type="submit">订阅</button>
      </form>
    </section>
  );
};

export default SubscribeSection; 